/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Template { 
    dateReference?: string;
    frontEndEnabled?: boolean;
    id?: string;
    isSchedulable?: boolean;
    messageKey?: string;
    name?: string;
    roles?: Array<string>;
    schema?: string;
    userReference?: string;
}
